import { defineTokens } from '@chakra-ui/react';
import { getFontFamilyForTenant } from '../../utils';

export const fonts = defineTokens.fonts({
  heading: {
    value: getFontFamilyForTenant(),
  },
  body: {
    value: getFontFamilyForTenant(),
  },
  mono: {
    value: getFontFamilyForTenant(),
  },
});
